import {
  BarChart3,
  BookOpen,
  Brain,
  ClipboardList,
  CreditCard,
  Crown,
  DollarSign,
  FileText,
  Gift,
  Heart,
  Lightbulb,
  ListVideo,
  Mail,
  MessageSquare,
  Mic,
  Activity,
  Settings,
  Sparkles,
  Target,
  Users,
  Video,
} from 'lucide-react';

export const ADMIN_ZONES = [
  {
    id: 'marketing',
    title: 'Marketing',
    question: 'What content is in flight, and where has it been distributed?',
    supportingLine: 'YouTube-first content waterfall — track every piece from idea to distributed.',
    icon: Mail,
    primaryRoomId: 'marketing',
    primaryTab: 'marketingcontent',
    roomIds: ['marketing'],
    tools: [
      { tab: 'marketingcontent', label: 'Content Queue', icon: Video, roomId: 'marketing' },
      { tab: 'marketingintelligence', label: 'Audience Intelligence', icon: Brain, roomId: 'marketing' },
      { tab: 'marketingplaylist', label: 'Playlist Intelligence', icon: ListVideo, roomId: 'marketing' },
    ],
  },
  {
    id: 'free-users',
    title: 'Free Users',
    question: 'Which unactivated or free-tier relationships should become clearer next?',
    supportingLine: 'This lane will hold nurture, conversion, and activation work once that flow is live.',
    icon: Users,
    primaryRoomId: 'free-users',
    primaryTab: 'freeuserscomingsoon',
    roomIds: ['free-users'],
    tools: [
      { tab: 'freeuserscomingsoon', label: 'Coming Soon', icon: Users, roomId: 'free-users' },
    ],
  },
  {
    id: 'communication',
    title: 'Prospects',
    question: 'Which prospects are warm enough for the next real move?',
    supportingLine: 'Prospects, guest passes, referrals, and early follow-up.',
    icon: Target,
    primaryRoomId: 'reach-dads',
    primaryTab: 'members',
    roomIds: ['reach-dads'],
    tools: [
      { tab: 'members', label: 'Prospects', icon: Users, roomId: 'reach-dads' },
      { tab: 'guestpasses', label: 'Guest Passes', icon: Gift, roomId: 'reach-dads' },
      { tab: 'email', label: 'Email', icon: Mail, roomId: 'reach-dads' },
    ],
  },
  {
    id: 'heart-work',
    title: 'Dad Partners',
    question: 'Which dads need care, follow-up, or support next?',
    supportingLine: 'Active dads, relationship follow-up, and the support assets that serve them.',
    icon: Heart,
    primaryRoomId: 'support-dads',
    primaryTab: 'members',
    roomIds: ['support-dads'],
    tools: [
      { tab: 'members', label: 'Dad Partners', icon: Users, roomId: 'support-dads' },
      { tab: 'email', label: 'Email', icon: Mail, roomId: 'support-dads' },
      { tab: 'feedback', label: 'Feedback', icon: MessageSquare, roomId: 'support-dads' },
      { tab: 'recordings', label: 'Recordings', icon: Video, roomId: 'support-dads' },
      { tab: 'prompts', label: 'Prompt Assistant', icon: Sparkles, roomId: 'support-dads' },
      { tab: 'gems', label: 'Gems', icon: Lightbulb, roomId: 'support-dads' },
      { tab: 'peersupport', label: 'Peer Support', icon: Heart, roomId: 'support-dads' },
      { tab: 'resources', label: 'Resources', icon: BookOpen, roomId: 'support-dads' },
      { tab: 'analytics', label: 'Analytics', icon: BarChart3, roomId: 'support-dads' },
    ],
  },
  {
    id: 'guide-partners',
    title: 'Guide Partners',
    question: 'Who should be invited, followed up with, or scheduled next?',
    supportingLine: 'Cultivation, onboarding, and long-term service.',
    icon: Mic,
    primaryRoomId: 'guide-partners',
    primaryTab: 'guestguides',
    roomIds: ['guide-partners'],
    tools: [
      { tab: 'guestguides', label: 'Guide Partners', icon: Mic, roomId: 'guide-partners' },
      { tab: 'email', label: 'Email', icon: Mail, roomId: 'guide-partners' },
    ],
  },
  {
    id: 'advisory-partners',
    title: 'Advisory Partners',
    question: 'Which advisory relationships or asks need a clearer next move?',
    supportingLine: 'Pattern-seeing partners, advisory access, and the private asks that need grounded response.',
    icon: Crown,
    primaryRoomId: 'advisory-partners',
    primaryTab: 'advisorycontent',
    roomIds: ['advisory-partners'],
    tools: [
      { tab: 'email', label: 'Email', icon: Mail, roomId: 'advisory-partners' },
      { tab: 'advisorycontent', label: 'Advisory Content', icon: FileText, roomId: 'advisory-partners' },
      { tab: 'advisorypartneraccounts', label: 'Partner Accounts', icon: Users, roomId: 'advisory-partners' },
    ],
  },
  {
    id: 'support-partners',
    title: 'Support Partners',
    question: 'Which supporters need care, trust-building, or clearer follow-through next?',
    supportingLine: 'Mission supporters, sync health, and the relational trust behind visible impact.',
    icon: Mail,
    primaryRoomId: 'support-partners',
    primaryTab: 'supportpartneraccounts',
    roomIds: ['support-partners'],
    tools: [
      { tab: 'email', label: 'Email', icon: Mail, roomId: 'support-partners' },
      { tab: 'supportpartneraccounts', label: 'Partner Accounts', icon: Users, roomId: 'support-partners' },
      { tab: 'supporters', label: 'Mission Support', icon: Mail, roomId: 'support-partners' },
      { tab: 'supportcontent', label: 'Support Partner Content', icon: FileText, roomId: 'support-partners' },
    ],
  },
  {
    id: 'super-fans',
    title: 'Super Fans',
    question: 'Which super-fan relationships need a cleaner access list or next move?',
    supportingLine: 'A deliberately shallow admin surface for access, fit, and follow-through.',
    icon: Sparkles,
    primaryRoomId: 'super-fans',
    primaryTab: 'superfanaccounts',
    roomIds: ['super-fans'],
    tools: [
      { tab: 'superfanaccounts', label: 'Super Fan Accounts', icon: Sparkles, roomId: 'super-fans' },
    ],
  },
  {
    id: 'stewardship',
    title: 'Operations',
    question: 'What business or admin work keeps Dad Partners healthy and dependable?',
    supportingLine: 'Pricing, settings, documents, and operational upkeep.',
    icon: Settings,
    primaryRoomId: 'steward-the-work',
    primaryTab: 'analytics',
    roomIds: ['steward-the-work', 'system-health'],
    tools: [
      { tab: 'analytics', label: 'Analytics', icon: BarChart3, roomId: 'steward-the-work' },
      { tab: 'pricing', label: 'Pricing', icon: DollarSign, roomId: 'steward-the-work' },
      { tab: 'featureplanning', label: 'Features & Operations', icon: ClipboardList, roomId: 'steward-the-work' },
      { tab: 'membershipenrollments', label: 'Membership Enrollments', icon: CreditCard, roomId: 'steward-the-work' },
      { tab: 'documents', label: 'Documents', icon: FileText, roomId: 'system-health' },
      { tab: 'sitesettings', label: 'Site Settings', icon: Settings, roomId: 'system-health' },
    ],
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    question: 'What needs attention right now across production and local watchers?',
    supportingLine: 'Live checks, incidents, and operator clarity.',
    icon: Activity,
    primaryRoomId: 'system-health',
    primaryTab: 'monitoring',
    roomIds: ['system-health'],
    tools: [
      { tab: 'monitoring', label: 'Monitoring', icon: Activity, roomId: 'system-health' },
    ],
  },
];

const ZONE_BY_ID = new Map(ADMIN_ZONES.map((zone) => [zone.id, zone]));
const ZONES_BY_ROOM_ID = new Map();
const PRIMARY_ZONE_BY_TAB = new Map();

for (const zone of ADMIN_ZONES) {
  for (const roomId of zone.roomIds || []) {
    const zones = ZONES_BY_ROOM_ID.get(roomId) || [];
    zones.push(zone);
    ZONES_BY_ROOM_ID.set(roomId, zones);
  }

  for (const tool of zone.tools || []) {
    if (!PRIMARY_ZONE_BY_TAB.has(tool.tab)) {
      PRIMARY_ZONE_BY_TAB.set(tool.tab, zone);
    }
  }
}

export function getAdminZoneById(zoneId) {
  return ZONE_BY_ID.get(zoneId) || null;
}

export function getAdminZoneForRoomId(roomId) {
  const zones = ZONES_BY_ROOM_ID.get(roomId) || [];
  return zones[0] || null;
}

export function getPrimaryZoneForTab(tab) {
  return PRIMARY_ZONE_BY_TAB.get(tab) || null;
}

export function getAdminZoneForRoomOrTab(roomId, tab) {
  if (roomId && tab) {
    const zones = ZONES_BY_ROOM_ID.get(roomId) || [];
    const matchingZone = zones.find((zone) => (
      (zone.tools || []).some((tool) => tool.tab === tab && (!tool.roomId || tool.roomId === roomId))
    ));
    if (matchingZone) {
      return matchingZone;
    }
  }

  return getPrimaryZoneForTab(tab) || getAdminZoneForRoomId(roomId) || ADMIN_ZONES[0];
}
